import * as LDClient from 'launchdarkly-js-client-sdk';
import { setupLegacy } from './index';
// import { injectV2Iframe } from './inject-v2-iframe';
import { injectV2Script } from './inject-v2-script';

/**
 * Find axo-root element and extract relevant attributes
 */
const validate = <T extends string>(
  value: string | null,
  validValues: T[]
): T | undefined =>
  validValues.includes(value as T) ? (value as T) : undefined;

const getAxoRootData = (): {
  market?: 'no' | 'fi';
  affiliateUrl?: string;
  variant?: 'main' | 'pre';
} => {
  const element = document.getElementById('axo-root');
  if (!element) return {};

  /**
   * `data-market` attribute is the default
   * older implementations use `data-config="https://form.axofinance.com/config/no/fullwidth.json"` for `no` and `data-config="https://form.axofinance.com/config/fullwidth.json"` for `fi`, so we need to deduct the market from it
   */

  let market = validate(element.getAttribute('data-market'), ['no', 'fi']);
  if (!market) {
    const config = element.getAttribute('data-config');
    market = config?.includes('no') ? 'no' : 'fi';
  }

  return {
    market,
    affiliateUrl:
      element.getAttribute('data-has-offers-affiliate-url') || undefined,
    variant: validate(element.getAttribute('data-form-variant'), [
      'main',
      'pre',
    ]),
  };
};

/**
 * Decide if we should use V2
 */
const shouldUseV2 = async (market: string | undefined): Promise<boolean> => {
  if (!market) return false;

  const cid = import.meta.env.VITE_LD_CLIENT_ID__SYSTEM;

  const ldClient = LDClient.initialize(cid, {
    kind: 'multi',
    runtime: {
      key: 'white-label',
    },
    country: {
      key: market.toLocaleLowerCase(),
    },
    host: {
      key: window.location.hostname,
    },
  });

  await ldClient.waitForInitialization();

  const flagKey = 'use-white-label-host';
  const useV2 = ldClient.variation(flagKey, 'off') === 'complete';

  ldClient.close();

  return useV2;
};

/**
 *
 */
const main = async () => {
  const { market, affiliateUrl, variant } = getAxoRootData();

  if (market && (await shouldUseV2(market))) {
    // Switch to V2 for specific markets (e.g., `no`)
    console.log(`Switching to V2 for market: ${market}`);
    injectV2Script(market, affiliateUrl, variant);
    // injectV2Iframe(market, affiliateUrl, variant);
  } else {
    // Default to V1 for all other cases
    console.log(`Using V1 for market: ${market}`);
    setupLegacy();
  }
};

main();
